import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    boolToBinary,
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    focusFormIdElement,
    getCurrUrlParamValue,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {RadioToggle, Select} from "../../common/fusion-ui";
import {CssVariant, Messages} from "../../common/fusion-ui/config/FusionConfig";
import {ThemedInput} from "../../common/components";
import {FormPageRoot} from "../components";
import {AppTextEditor} from "../../app";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const ExpSpeaks__AddEditFormPage = React.memo(({
                                                   updateOnly,
                                                   open,
                                                   onHide,
                                                   recordId,
                                                   showAs = ShowViewType.PAGE,
                                                   onSuccess,
                                               }) => {
    const TAG = "ExpSpeaks__AddEditFormPage";

    const moduleName = AdminModules.ExpertSpeaks;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        companies: 'companies',
        showCompaniesLoading: 'showCompaniesLoading',
        isCompDataFetched: 'isCompDataFetched',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(ExpSpeaks__AddEditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId, 'updateOnly:', isUpdateMode());
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && (isUpdateMode())) {
                fetchEditModeData(recordId, false);
            }
        }
        fetchCompanies();
    }, [recordId, showAs, updateOnly]);

    return (<>
            <FormPageRoot
                tag={TAG}
                moduleName={moduleName}
                updateOnly={isUpdateMode()}
                isDataLoading={getField(Fields.isDataLoading)}
                isDataFound={getField(Fields.isDataFound)}
                dataLoadingMsg={getField(Fields.dataLoadingMsg)}
                open={open}
                onHide={() => {
                    if (onHide) onHide();
                    clearPanelData(true);
                }}
                showAs={showAs}
                md={10}
                panelMsg={getField(Fields.panelMsg)}
                panelMsgColor={getField(Fields.panelMsgColor)}
                isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
                isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                onSubmit={handleSubmit}
                onPageRefresh={() => fetchEditModeData(getField(Fields.updateRecordId), false)}
            >
                <div className={''}>
                    {/*company-select*/}
                    <Select
                        id={mf.companyId.column}
                        wrapperClassName={`w-100`}
                        className={`w-100 rounded-3 py-2`}
                        innerWrapperClassName={'w-100'}
                        labelClassName={'w-100 text-input-label'}
                        variant={'primary'}
                        justifyAt={'center'}
                        labelColor={theme.text40}
                        label={mf.companyName.title}
                        placeholder={'Select a company'}
                        wrap={'wrap'}
                        textKey={'text'}
                        idKey={'id'}
                        required={true}
                        options={getField(Fields.companies, [])}
                        defOption={getFormField(mf.companyId)}
                        showLoader={isFieldTrue(Fields.showCompaniesLoading)}
                        showRefresh={true}
                        onRefresh={() => fetchCompanies(false)}
                        onChange={(e, text, value) => {
                            log('comp.Select.onChange::text:', text, "value:", value);
                            updateFormField(mf.companyId, value);
                            updateFormField(mf.companyName, text);
                        }}
                    />

                    {/*description*/}
                    <div className={'mt-3'}>
                        <AppTextEditor
                            required={true}
                            id={mf.description.column}
                            label={mf.description.title}
                            labelColor={theme.text40}
                            value={getFormField(mf.description)}
                            onChange={(content) => {
                                updateFormField(mf.description, content);
                            }}/>
                    </div>

                    {/*title*/}
                    <ThemedInput
                        wrapperClassName={'mt-3'}
                        className={''}
                        label={mf.title.titleAlt}
                        placeholder={mf.title.titleAlt}
                        id={mf.title.column}
                        value={getFormField(mf.title)}
                        msg={getFormFieldMsg(mf.title)}
                        required={true}
                        type={'text'}
                        onChange={(e) => {
                            const value = e.target.value + '';
                            updateFormField(mf.title, value);
                            panelLog('');
                            if (checkNullStr(value)) updateFormFieldMsg(mf.title, '');
                        }}
                    />

                    {/*isActive*/}
                    {isUpdateMode() &&
                        <RadioToggle
                            radioClassName={'w-auto'}
                            labelColor={theme.text40}
                            binary={true}
                            required={true}
                            checked={boolToBinary(isFormFieldTrue(mf.status))}
                            config={{
                                label: mf.status.titleAlt,
                                active: "YES", inactive: "NO"
                            }}
                            onChange={(e, value) => {
                                log('status.onChange.value:', value);
                                updateFormField(mf.status, value);
                            }}
                        />}
                </div>
            </FormPageRoot>
        </>
    )

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__expSpk_addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData(true);
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchCompanies(checkBefore = true) {
        const fun = 'fetchCompanies:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isCompDataFetched))) {
            updateField(Fields.isCompDataFetched, true);
            updateField(Fields.showCompaniesLoading, true);
            updateField(Fields.companies, []);
            updateFormField(mf.companyId, null);
            updateFormField(mf.companyName, null);
            try {
                //send-request
                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__company__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        let comps = getJsonValue(fetchedData, 'data', []);
                        const success = checkNullArr(comps);
                        if (success) {
                            //format list
                            const mf_comp = AdminModuleFieldsData[AdminModules.Company];
                            comps = comps.map((item) => {
                                return {
                                    id: getJsonValue(item, mf_comp.recordId.title),
                                    text: getJsonValue(item, mf_comp.companyName.title),
                                };
                            }).filter(item => checkNullJson(item));
                            log(fun, 'fetchedData.comps:', comps);

                            updateField(Fields.companies, comps);
                        } else {
                            toast("No companies found!", CssVariant.danger);
                        }
                        updateField(Fields.showCompaniesLoading, false);
                    }),
                    onError: ((error) => {
                        toast("Couldn't load companies, please try again!", CssVariant.danger);
                        updateField(Fields.showCompaniesLoading, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast("Couldn't load companies, please try again!", CssVariant.danger);
                updateField(Fields.showCompaniesLoading, false);
                logErr(fun, error);
            }
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setFormData({});
                    setFormFieldsMsgs({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__expSpk_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: (async (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [mf.companyId, mf.description, mf.title];

        let verified = false;
        let colField = {};
        for (const loopField of requiredFields) {
            const fieldValue = formData[loopField.column];
            if (!checkNullStr(fieldValue)) {
                colField = loopField;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData(refetchAddFormData = false) {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
        if (isBoolTrue(refetchAddFormData) && showAs != ShowViewType.PAGE && !isUpdateMode()) {
            updateField(Fields.dataLoadingMsg, '');
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
            fetchCompanies(false);
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default ExpSpeaks__AddEditFormPage;
